import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import navlinks from "./navlinks";
import classes from "./NavigationBar.module.css";
import { AiFillCaretDown } from "react-icons/ai";
import DropdownMenu from "./Dropdownmenu/DropdownMenu";

const NavigationBar = () => {
  const [showDropDown, setShowDropDown] = useState(false);
  const navigate = useNavigate();

  const showDropDownHandler = () => {
    setShowDropDown(true);
  };
  const hideDropDownHandler = () => {
    setShowDropDown(false);
  };
  function scrollToTestDiv(id) {
    navigate("/");
    const divElement = document.getElementById(id);
    divElement.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <nav className={classes["main-nav-container"]}>
      {navlinks.map((navlink, linkIndex) => {
        const { name, path } = navlink;

        return (
          <Link
            key={linkIndex}
            to={path}
            className={`${
              name === "Contact us" &&
              classes["main-nav-container__link-contact-us"]
            }`}
            onMouseEnter={name === "Products" ? showDropDownHandler : undefined}
            onMouseLeave={name === "Products" ? hideDropDownHandler : undefined}
            onClick={() => {
              name !== "Home" && name !== "Products" && scrollToTestDiv(path);
            }}
          >
            {name}
            {name === "Products" && (
              <>
                <AiFillCaretDown />
                {showDropDown && <DropdownMenu />}
              </>
            )}
          </Link>
        );
      })}
    </nav>
  );
};

export default NavigationBar;
